export function acNullify(val) {
    // console.log('acNullify - ', val);
    return {
        type: 'POP-UP-TABEL',
        payload: null
    }

}
